import { Icon } from '@/components/icon';

export function LoadingState() {
  return <div className="skeleton-grid" aria-label="Loading analytics">
    {Array.from({ length: 8 }, (_, index) => <div className="skeleton" key={index} />)}
  </div>;
}

export function ErrorState({ message, onRetry }: { message: string; onRetry: () => void }) {
  return <div className="state-panel" role="alert">
    <span className="state-panel__icon"><Icon name="vitality" size={22} /></span>
    <h2>Analytics could not load</h2>
    <p>{message}</p>
    <button className="button button--primary" onClick={onRetry}>Try again</button>
  </div>;
}
